import { render } from "./MaterialSnackbar.vue?vue&type=template&id=850a758e&scoped=true"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"

import "./MaterialSnackbar.vue?vue&type=style&index=0&id=850a758e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850a758e"]])

export default __exports__